/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  PresenterNavisOfficeExistenceResponse,
  PresenterNavisOfficeUserDeletableResponse,
  PresenterTenantActivationStatusesRequest,
  PresenterTenantActivationStatusesResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class InternalApi<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description Returns deletable. When false, messages holds one localized string (Accept-Language en vs default ja).
   *
   * @tags internal_api
   * @name OfficeUsersDeletableList
   * @summary Whether the office user may be deleted in Navis
   * @request GET:/internal/office_users/{id}/deletable
   * @secure
   */
  officeUsersDeletableList = (id: number, params: RequestParams = {}) =>
    this.http.request<PresenterNavisOfficeUserDeletableResponse, any>({
      path: `/internal/office_users/${id}/deletable`,
      method: "GET",
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Returns existence for the given Navis tenant ID
   *
   * @tags internal_api
   * @name OfficesExistenceList
   * @summary Whether the office exists in Asset Accounting
   * @request GET:/internal/offices/{id}/existence
   * @secure
   */
  officesExistenceList = (id: number, params: RequestParams = {}) =>
    this.http.request<PresenterNavisOfficeExistenceResponse, any>({
      path: `/internal/offices/${id}/existence`,
      method: "GET",
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Returns one row per requested tenant_uid with activated_at (null if not activated)
   *
   * @tags internal_api
   * @name TenantActivationStatusesCreate
   * @summary List tenant activation statuses
   * @request POST:/internal/tenant_activation_statuses
   * @secure
   */
  tenantActivationStatusesCreate = (
    body: PresenterTenantActivationStatusesRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<PresenterTenantActivationStatusesResponse[], any>({
      path: `/internal/tenant_activation_statuses`,
      method: "POST",
      body: body,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
